import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

import AutoDeliveryStatusInactiveDetailsPopup from './AutoDelivery/AutoDeliveryStatusInactiveDetailsPopup';
import AutoDeliveryDcxStatusInactiveDetailsPopup from './AutoDeliveryDcx/AutoDeliveryDcxStatusInactiveDetailsPopup';

const AutoDeliveryStatusInactiveDetailsPopupSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    return isDcx ? (
        <AutoDeliveryDcxStatusInactiveDetailsPopup {...props} />
    ) : (
        <AutoDeliveryStatusInactiveDetailsPopup {...props} />
    );
};

export default AutoDeliveryStatusInactiveDetailsPopupSwitcher;
